import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-labelledby="guarantee-title" className="bg-paper" data-id="element-130" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 px-5 py-20 text-center sm:px-8 md:flex-row md:text-left lg:py-24" data-id="element-131" data-mp="1o5zsw7kn0l79">
        <div className="relative flex h-40 w-40 shrink-0 flex-col items-center justify-center rounded-full bg-gold-wash ring-[6px] ring-gold/60 ring-offset-4 ring-offset-paper" data-id="element-132" data-mp="1x41zr3r1y82g">
          <ShieldCheckIcon className="h-8 w-8 text-gold-deep" aria-hidden="true" data-id="element-133" data-mp="14fxs4cox7kx4" />
          <span className="mt-1 font-display text-5xl leading-none text-navy" data-id="element-134" data-mp="14dtfn6cyhdl8">7</span>
          <span className="text-xs font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-135" data-mp="1j6n8rul5hs8d">Day guarantee</span>
        </div>
        <div data-id="element-136" data-mp="qo9h6cqer2hq">
          <h2 id="guarantee-title" className="font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-137" data-mp="qnpy2sp0u824">
            Try It for 7 Days
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-138" data-mp="lowmx6x7it54">
            Download the bundle, look through the printables, and print a few. If you decide it isn’t right for you, just contact us within 7
            days of your purchase and we’ll refund your payment.
          </p>
          <p className="mt-3 font-bold text-navy" data-id="element-139" data-mp="yq4juz5dxtl9">Simple, clear, and no pressure.</p>
        </div>
      </div>
    </section>;
}